import nl from './nl.json';
import en from './en.json';

export const defaultLocale = _getLocale();

export const languages = {
    nl,
    en
};

function _getLocale(){
    const lang = navigator.language;
    if(lang.toLowerCase().match('nl')){
        return 'nl';
    }
    return 'en';
}